export default __webpack_public_path__ + "static/media/notifications-icon.b6ad90ac.svg";